import {
  IS_T1_PAGE,
  IS_VLP_PAGE,
  IS_VDP_PAGE,
  IS_OFFERS_PAGE,
  IS_BUILD_PAGE,
  IS_MODELS_PAGE,
  IS_FYM_PAGE,
} from '../constants/environment';

interface EnvOverrides {
  url?: string;
  isT1?: boolean;
  isVlp?: boolean;
  isVdp?: boolean;
  isOffers?: boolean;
  isBuild?: boolean;
  isModels?: boolean;
  isFym?: boolean;
}

const useSourceOfLead = (
  _topicOfInterest?: string,
  presetForm?: string | null,
  overrides: EnvOverrides = {}, // Default to an empty object for production
) => {
  // Use the override if provided in testing, otherwise fallback to the real window
  const url = overrides.url ?? (typeof window !== 'undefined' ? window.location.href : '');

  // An Immediately Invoked Function Expression (IIFE) keeps the code clean
  // without the performance penalty of useMemo
  const specificSource = (() => {
    if (presetForm === 'testDrive') return 'testDrive';
    if (presetForm === 'tradeIn') return 'tradein';
    if (presetForm === 'generic' || presetForm === 'general') return 'generic';
    if (presetForm === 'military') return 'military';
    if (presetForm === 'eventTOR') return 'event_TOR';
    if (presetForm === 'eventMTL') return 'event_MTL';
    if (presetForm === 'eventVAN') return 'event_VAN';
    if (presetForm === 'eventEDM') return 'event_EDM';

    // Check overrides first, then fallback to environment constants
    if (overrides.isVlp ?? IS_VLP_PAGE) return 'vlp';
    if (overrides.isVdp ?? IS_VDP_PAGE) return 'vdp';
    if (overrides.isOffers ?? IS_OFFERS_PAGE) return 'offers';
    if (overrides.isBuild ?? IS_BUILD_PAGE) return 'config';
    if (overrides.isModels ?? IS_MODELS_PAGE) return 'mlp';
    if (overrides.isFym ?? IS_FYM_PAGE) return 'fym';

    return 'generic';
  })();

  const requestSource = (overrides.isT1 ?? IS_T1_PAGE) ? 'tier_1' : 'tier_3';

  return { url, specificSource, requestSource };
};

export default useSourceOfLead;
